// "Sobre este aparelho" (/conta): navegador e sistema a partir do user agent e o texto de "Copiar diagnóstico".
// Puro (testado em node: web/test/account.test.ts). Nada de conteúdo, e-mail ou token no diagnóstico.

const version = (ua: string, re: RegExp) => ua.match(re)?.[1].replace(/_/g, ".");

/** Nome curto do navegador e do sistema. A ordem importa: Edge e Opera também dizem "Chrome"; Chrome também diz "Safari". */
export function platformOf(ua: string): { browser: string; os: string } {
  const browsers: [string, RegExp][] = [
    ["Edge", /Edg(?:A|iOS)?\/(\d+)/],
    ["Opera", /OPR\/(\d+)/],
    ["Samsung Internet", /SamsungBrowser\/(\d+)/],
    ["Firefox", /(?:Firefox|FxiOS)\/(\d+)/],
    ["Chrome", /(?:Chrome|CriOS)\/(\d+)/],
    ["Safari", /Version\/([\d.]+).*Safari\//],
  ];
  const found = browsers.find(([, re]) => re.test(ua));
  const browser = found ? `${found[0]} ${version(ua, found[1])}` : "desconhecido";
  const ios = version(ua, /(?:iPhone|iPad|iPod).*? OS ([\d_]+)/);
  const android = version(ua, /Android ([\d.]+)/);
  const os = ios
    ? `iOS ${ios}`
    : android
      ? `Android ${android}`
      : /Windows/.test(ua)
        ? "Windows"
        : /Mac OS X|Macintosh/.test(ua)
          ? "macOS"
          : /CrOS/.test(ua)
            ? "ChromeOS"
            : /Linux/.test(ua)
              ? "Linux"
              : "desconhecido";
  return { browser, os };
}

/** Linhas "rótulo: valor" com um título: o que a pessoa cola numa mensagem de suporte. */
export const diagnosticText = (facts: [string, string][]) => ["fai.g — diagnóstico", ...facts.map(([k, v]) => `${k}: ${v}`)].join("\n");
